module.exports = __webpack_public_path__ + "img/hotel1.295e78bd.png";